{
  "firmwareFilterBar": {
    "label": "All",
    "label2": "Update available",
    "placeholder": "Search by camera name or area name",
    "label3": "Status"
  },
  "firmwareTable": {
    "label": "Camera name",
    "label2": "Area name",
    "label3": "Version",
    "label4": "Updated",
    "label5": "Status",
    "text": "No cameras are waiting for an update.",
    "button": "View all cameras"
  },
  "useFirmwareViewState": {
    "text": "Old version"
  },
  "firmware": {
    "enqueueSnackbar": "Firmware update started.",
    "enqueueSnackbar2": "The firmware update couldn't be configured.",
    "title": "Firmware management",
    "text": "Not supported",
    "text4": "Waiting to update",
    "text5": "Updating",
    "text6": "Failed",
    "text7": "Unknown",
    "text8": "N/A",
    "text9": "Up to date",
    "text10": "Update available"
  }
}
